module.exports = __webpack_public_path__ + "media/packs/images/flags/CR-8dbf70668c1951101cbb0bf6b893e0b0.png";